import { isAuthenticated } from '@cronos-app/api';
import { currentWallet } from '@cronos-app/wallet';
import { useQuery } from '@tanstack/react-query';

/**
 * if we have a valid access token for this wallet, directly returns true.
 * otherwise try to get it at server and refresh it locally, and return
 * true if it succeeds. if it fails return false.
 */
export const useIsAuthenticated = () => {
  const walletAddress = currentWallet.useAccount() ?? '';

  return useQuery(
    [useIsAuthenticated.queryKey, walletAddress],
    () => isAuthenticated(walletAddress),
    {
      enabled: !!walletAddress,
      retry: false,
    },
  );
};
useIsAuthenticated.queryKey = ['useIsAuthenticated'];
